import { Injectable } from '@angular/core';

@Injectable()
export class GoogleMapsLoaderService {
  apiKey = 'AIzaSyDTh-GM44cFDU8qv8rLl2QSFTB5-oN14m8';
  private scriptLoaded = false;

  load(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this.scriptLoaded) {
        resolve();
        return;
      }

     /*const existingScript = document.querySelector(`script[src="https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places"]`);
      if (existingScript) {
          this.scriptLoaded = true;
          resolve();
          return;
      }*/

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };
      script.onerror = (error) => reject(error);

      document.head.appendChild(script);
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/google-maps-loader.service.ts